export default "__VITE_ASSET__CNVb6YDT__"